export const OmitModes = {
	omitActions: "omitActions",
	omitAdministrative: "omitAdministrative",
};